import { render, staticRenderFns } from "./logs.vue?vue&type=template&id=4024ce9b&scoped=true"
import script from "./logs.vue?vue&type=script&lang=js"
export * from "./logs.vue?vue&type=script&lang=js"
import style0 from "./logs.vue?vue&type=style&index=0&id=4024ce9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4024ce9b",
  null
  
)

export default component.exports